import axios from "axios";

export default {
    namespaced: true,

    state: {
        mapGroups: [],
        allMapGroupsFilters: {
            sort: "id",
            search: null,
            sortOrder: "desc",
            offset: 0,
            limit: 50,
        },
        totalCount: 0,
        filteredResultsCount: 0,
        publishedMapGroups: [],
    },

    getters: {
        mapGroups(state) {
            return state.mapGroups;
        },
        publishedMapGroups(state) {
            return state.publishedMapGroups;
        },
        totalCount(state) {
            return state.totalCount;
        },
        filteredResultsCount(state) {
            return state.filteredResultsCount;
        },
    },

    mutations: {
        SET_ALL_GROUPS(state, mapGroups) {
            state.mapGroups = mapGroups;
        },
        SET_ALL_PUBLISHED_MAP_GROUPS(state, publishedMapGroups) {
            state.publishedMapGroups = publishedMapGroups;
        },
        SET_FILTERS(state, value) {
            state.allMapGroupsFilters = value;
        },
        SET_FILTERED_RESULTS_TOTAL_COUNT(state, count) {
            state.filteredResultsCount = count;
        },
    },

    actions: {
        async getAllMapsGroups({ commit, state }) {
            return await axios
                .get("/api/get-all-groups", {
                    params: state.allMapGroupsFilters,
                })
                .then((response) => {
                    commit("SET_ALL_GROUPS", response.data.map_groups);
                    commit(
                        "SET_FILTERED_RESULTS_TOTAL_COUNT",
                        response.data.filterd_results_count
                    );
                    return response;
                });
        },
        async getPublishedMapGroups({ commit, state }) {
            return await axios
                .get("/api/get-published-map-groups")
                .then((response) => {
                    response.data.map((group) => {
                        group.active_maps.map(
                            (mapItem) => (mapItem.selected = false)
                        );
                    });
                    commit("SET_ALL_PUBLISHED_MAP_GROUPS", response.data);
                    return response;
                });
        },
        async saveNewMapGroupWord({ commit }, payload) {
            await axios
                .post("/api/create-map-group", payload)
                .then((response) => {});
        },
        async getMapGroup({ commit }, id) {
            return await axios.get("/api/get-map-group", {
                params: { id },
            });
        },
        async updateMapGroup({ commit }, payload) {
            await axios
                .post("/api/update-map-group", payload)
                .then((response) => {});
        },
        async deleteMapGroup({ commit }, id) {
            await axios
                .post("/api/delete-map-group", { id })
                .then((response) => {});
        },
        async updateData({ dispatch }) {
            await dispatch("getAllMapsGroups");
        },
    },
};
